import React from 'react';
import ScrollSnapSliderContext from '../context/ScrollSnapSliderContext';

export default function useScrollSnapSliderContext() {
    return React.useContext(ScrollSnapSliderContext);
}
